module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0034.jpg?v=dcba996e";